import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/faq',
    name: 'FeedbackAndQuestion',
    component: () => import('../views/FeedbackAndQuestion.vue')
  },
  {
    path: '/giftWall/faq',
    name: 'GiftWallFeedBackAndQuestion',
    component: () => import('../views/GiftWallFeedBackAndQuestion.vue')
  },
  {
    path: '/userLevel',
    name: 'UserLevel',
    component: () => import('../views/UserLevel.vue')
  },
  {
    path: '/appInvite',
    name: 'AppInvite',
    component: () => import('../views/AppInvite.vue')
  },
  {
    path: '/taskLotteryView',
    name: 'TaskLotteryView',
    component: () => import('../views/task/TaskLotteryView.vue')
  },
  {
    path: '/uploadMusicRule',
    name: 'UploadMusicRule',
    component: () => import('../views/UploadMusicRule.vue')
  },
  {
    path: '/enableAppeal',
    name: 'enableAppeal',
    component: () => import('../views/EnableAppeal.vue')
  },
  {
    path: '/enableRecord',
    name: 'enableRecord',
    component: () => import('../views/EnableRecord.vue')
  },
  {
    path: '/enableRecordDetail',
    name: 'RecordDetail',
    component: () => import('../views/EnableRecordDetail.vue')
  },
  {
    path: '/soltGameView',
    name: 'soltGameView',
    component: () => import('../views/SoltGame.vue')
  },
  {
    path: '/cardUseRecord',
    name: 'cardUseRecord',
    component: () => import('../views/CardUseRecord.vue')
  },
  {
    path: '/svipSystem',
    name: 'svipSystem',
    component: () => import('../views/svip/SvipSystem.vue')
  },
  {
    path: '/svipRule',
    name: 'svipRule',
    component: () => import('../views/svip/SvipRule.vue')
  },
  {
    path: '/svipPoint',
    name: 'svipPoint',
    component: () => import('../views/svip/SvipPoint.vue')
  },
  {
    path: '/svipPrivileges',
    name: 'svipPrivileges',
    component: () => import('../views/svip/SvipPrivileges.vue')
  },
  {
    path: '/rechargeNoReceiveFeedback',
    name: 'rechargeNoReceiveFeedback',
    component: () => import('../views/RechargeNoReceiveFeedback.vue')
  },
  {
    path: '/rechargeNoReceiveFeedbackRecord',
    name: 'rechargeNoReceiveFeedbackRecord',
    component: () => import('../views/RechargeNoReceiveFeedbackRecord.vue')
  },
  {
    path: '/appFeedback',
    name: 'appFeedback',
    component: () => import('../views/AppFeedback.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
